import DataViewImage from "@/Components/Images/DataViewImage/DataViewImage";
import DataDescription from "@/Components/View/DescriptionData/DataDescription";
import DataInformation from "@/Components/View/InformationData/DataInformation";
import { useContextProductData } from "@/Context/Product/ContextProductProvider";
import useWindowsSize from "@/Hooks/useWindowsSize";
import { ReplaceCharacter } from "@/Utils/RemplaceCharacter";
import React, { lazy, Suspense } from "react";
import Skeleton from "react-loading-skeleton";
import { Link, useParams } from "react-router-dom";

const LayoutHomeThree = lazy(
  () => import("@/Layout/HomeThree/LayoutHomeThree")
);

type paramSubCategory = { cteg?: string; subcateg: string };

const stylesd: React.CSSProperties = {
  maxWidth: "233px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const PagePDP = () => {
  const { width } = useWindowsSize();
  const { cteg, subcateg } = useParams<paramSubCategory>();
  const { Products, isLoading, Categories, SubCategories } =
    useContextProductData();

  //console.log("producto Datos :" , Products)

  const linkToElect = "/Electrónicav2";
  const Productos = Products.map((item) => item)[0];
  const sourceImageV2 = Productos?.ImageGroups?.map((x) => {
    const allLinks = x?.images?.flatMap((t) => t.link);
    return allLinks;
  })[0];
  const promotionsDescription = Productos?.Promotions?.map(
    (x) => x?.description
  );
  const promotions = Productos?.Promotions?.map((x) => x?.color);

  return (
    <Suspense>
      <LayoutHomeThree
        toLink={`${linkToElect}/${cteg}/${subcateg}`}
        PLP={false}>
        {/* Product Detail */}
        <div className="ps-breadcrumb">
          <div className="ps-container">
            {isLoading ? (
              <Skeleton />
            ) : (
              <ul className="breadcrumb">
                <li>
                  <Link to="/">Inicio</Link>
                </li>
                <li>
                  <Link to={`${linkToElect}`}>Electrónica</Link>
                </li>
                <li style={width < 540 ? stylesd : {}}>
                  <Link to={`${linkToElect}`}>{ReplaceCharacter(cteg!)}</Link>
                </li>
                <li style={width < 540 ? stylesd : {}}>
                  <Link to={`${linkToElect}/${cteg}/${subcateg}`}>
                    {ReplaceCharacter(subcateg!)}
                  </Link>
                </li>
                <li style={width < 540 ? stylesd : {}}>{Productos?.Name}</li>
              </ul>
            )}
          </div>
        </div>
        <div className="ps-page--product">
          <div className="ps-container">
            {/* parte de la información y vista de imagenes*/}
            <div className="ps-page__container">
              <div className="ps-page__left">
                <div className="ps-product--detail ps-product--fullwidth">
                  <div className="ps-product__header">
                    <DataViewImage
                      sourceImage={sourceImageV2 ?? []}
                      isLoading={isLoading}
                    />
                    <div className="ps-product__info">
                      {/* {!isLoading && (
                        <DataInformation
                          CategoriesFather={cteg!}
                          Products={Products ?? []}
                          PromotionsDescription={promotionsDescription ?? []}
                          Promotions={promotions ?? []}
                        />
                      )} */}
                      <DataInformation
                        CategoriesFather={cteg!}
                        Products={Products ?? []}
                        PromotionsDescription={promotionsDescription ?? []}
                        Promotions={promotions ?? []}
                      />
                    </div>
                  </div>
                  <div className="ps-product__content ps-tab-root">
                    {!isLoading && <DataDescription />}
                  </div>
                </div>
              </div>
              <div className="ps-page__right">
                <aside className="widget widget_product widget_features">
                  <p>
                    <i className="icon-network"></i> Shipping worldwide
                  </p>
                  <p>
                    <i className="icon-3d-rotate"></i> Free 7-day return if
                    eligible, so easy
                  </p>
                  <p>
                    <i className="icon-receipt"></i> Supplier give bills for
                    this product.
                  </p>
                  <p>
                    <i className="icon-credit-card"></i> Pay online or when
                    receiving goods
                  </p>
                </aside>
              </div>
            </div>
            {/* parte donde se ve los detalles*/}
            {/* <div className="ps-section--default ps-customer-bought">
              <div className="ps-section__header">
                <h3>Customers who bought this item also bought</h3>
              </div>
              <div className="ps-section__content">
                <ProductosLista />
              </div>
            </div> */}
            {/* parte se ven los demas articulos segun por la categoria o sub categoria. */}
            {/* <div className="ps-section--default">
              <div className="ps-section__header">
                <h3>Related products</h3>
              </div>
              <div className="ps-section__content">
                <ProductosView />
              </div>
            </div> */}
          </div>
        </div>
      </LayoutHomeThree>
    </Suspense>
  );
};

export default PagePDP;
